module.exports = "\n\n<router-outlet></router-outlet>\n<br><br><br>\n<footer>\n    <p>\n        Gestión Hotel Copyright © 2018 Infitec\n    </p>\n  </footer>"